import { Box, Typography, Divider, useMediaQuery, useTheme } from '@mui/material';
import P47 from '../../../../Assets/Icons/P47logo.svg';
import dangal from '../../../../Assets/images/dangal.svg';
import heroVisual from '../../../../Assets/images/heroimg.jpg';
import Ideabaaz from '../../../../Assets/images/ideabaaz.svg';
import zee from '../../../../Assets/images/zeeLogo.svg';
import ideaIcon from '../../../../Assets/images/idea.svg';
import dangalIcon from '../../../../Assets/images/dangal copy.svg';
import { useStyles } from './styles';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';
const Hero = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Placeholder auth check; replace with real logic
  const isAuthenticated = false;

  // Responsive dimensions
  const boxWidth = isMobile ? '100%' : '250px';
  const wrapperPadding = isMobile ? '10px' : '20px';
  const wrapperGap = isMobile ? '20px' : '40px';

  return (
    <Box
      className={classes.heroSection}
      style={{
        willChange: 'transform',
        transform: 'translateZ(0)',
      }}
    >
      <Box className={classes.contentWrapper}>
        {/* Logo row */}
        {/* <Box className={classes.logoRow}>
          <img src={Ideabaaz} alt="Ideabaaz" className={classes.logoImage} onClick={() => navigate(routes.login)} />
          <Box className={classes.divider} />
          <img src={P47} alt="Project 47" className={classes.logoImage} onClick={() => window.open('https://project47.ideabaaz.co.in')} />
          <Box className={classes.divider} />
          <img src={dangal} alt="Dangal" className={classes.logoImage} onClick={() => window.open('https://www.ideabaazdangal.com/register')} />
        </Box> */}

        {/* Date pill */}
        <Box className={classes.datePillContainer}>
          <Box sx={{ fontSize: '12px' }}> Coming Soon! only on</Box>
          <img src={zee} alt="zeeTV" className={classes.zeeLogo} />
        </Box>

        {/* Headings */}
        <Typography variant="h1" className={classes.mainHeading}>
          A nation of ideas. <br /> Now with a stage.
        </Typography>
        <Typography className={classes.subtext}>Ideabaaz is a national platform for breakthrough startups, spotlighting ventures from every corner of the country</Typography>

        {/* Blur-backdrop wrapper with two equal panels - RESPONSIVE */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            flexDirection: {
              xs: 'row', // Stack vertically on mobile
              sm: 'row', // Stack vertically on small tablets
              md: 'row', // Side by side on medium screens and up
            },
            margin: '0 auto 10px',
            gap: '20px',
            padding: {
              xs: '12px', // Tighter padding on mobile
              sm: '15px', // Default padding
            },
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            borderRadius: {
              xs: '8px', // Smaller radius on mobile
              sm: '12px', // Default radius
            },
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
          }}
        >
          {/* Panel 1: Idea icon + Startup button */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: {
                xs: '12px', // Smaller gap on mobile
                sm: '16px', // Default gap
              },
            }}
          >
            <Box onClick={() => window.open('https://www.ideabaazdangal.com/register', '_blank')}>
              <Typography className={classes.SubmitNowBtn}>
                {/* {isAuthenticated ? 'Dashboard' : 'Startup? – Register Here'} */}
                Register your idea
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.75 4.42578C4.05964 4.42578 3.5 4.98543 3.5 5.67578V12.1758C3.5 12.8661 4.05964 13.4258 4.75 13.4258H11.25C11.9404 13.4258 12.5 12.8661 12.5 12.1758V10.6758C12.5 10.2616 12.8358 9.92578 13.25 9.92578C13.6642 9.92578 14 10.2616 14 10.6758V12.1758C14 13.6946 12.7688 14.9258 11.25 14.9258H4.75C3.23122 14.9258 2 13.6946 2 12.1758V5.67578C2 4.157 3.23122 2.92578 4.75 2.92578H6.25C6.66421 2.92578 7 3.26157 7 3.67578C7 4.08999 6.66421 4.42578 6.25 4.42578H4.75ZM7.99976 3.67578C7.99976 3.26157 8.33554 2.92578 8.74976 2.92578H13.2498C13.664 2.92578 13.9998 3.26157 13.9998 3.67578V8.17578C13.9998 8.58999 13.664 8.92578 13.2498 8.92578C12.8355 8.92578 12.4998 8.58999 12.4998 8.17578V5.48673L9.28008 8.70634C8.98719 8.99924 8.51231 8.99923 8.21942 8.70634C7.92653 8.41344 7.92653 7.93857 8.21943 7.64568L11.4394 4.42578H8.74976C8.33554 4.42578 7.99976 4.08999 7.99976 3.67578Z"
                    fill="#E1490A"
                  />
                </svg>
              </Typography>
            </Box>
          </Box>

          {/* Panel 2: Dangal icon + Idea button */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: {
                xs: '12px', // Smaller gap on mobile
                sm: '16px', // Default gap
              },
            }}
          >
            <Box onClick={() => navigate('/signup?applicationName=ideaBaaz')}>
              <Typography className={classes.ctaBtn}>
                Register your startup{' '}
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.75 4.42578C4.05964 4.42578 3.5 4.98543 3.5 5.67578V12.1758C3.5 12.8661 4.05964 13.4258 4.75 13.4258H11.25C11.9404 13.4258 12.5 12.8661 12.5 12.1758V10.6758C12.5 10.2616 12.8358 9.92578 13.25 9.92578C13.6642 9.92578 14 10.2616 14 10.6758V12.1758C14 13.6946 12.7688 14.9258 11.25 14.9258H4.75C3.23122 14.9258 2 13.6946 2 12.1758V5.67578C2 4.157 3.23122 2.92578 4.75 2.92578H6.25C6.66421 2.92578 7 3.26157 7 3.67578C7 4.08999 6.66421 4.42578 6.25 4.42578H4.75ZM7.99976 3.67578C7.99976 3.26157 8.33554 2.92578 8.74976 2.92578H13.2498C13.664 2.92578 13.9998 3.26157 13.9998 3.67578V8.17578C13.9998 8.58999 13.664 8.92578 13.2498 8.92578C12.8355 8.92578 12.4998 8.58999 12.4998 8.17578V5.48673L9.28008 8.70634C8.98719 8.99924 8.51231 8.99923 8.21942 8.70634C7.92653 8.41344 7.92653 7.93857 8.21943 7.64568L11.4394 4.42578H8.74976C8.33554 4.42578 7.99976 4.08999 7.99976 3.67578Z"
                    fill="white"
                  />
                </svg>
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Hero image */}
        <Box className={classes.heroImageWrapper}>
          <img src={heroVisual} alt="Hero Visual" className={classes.heroImage} />
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
